
import { Component, Vue } from 'vue-property-decorator'
import { Pagination } from '@/components/common/organisms/PaginationButton.vue'

export type BranchData = {
  branchName: string
}

export type TeacherForBranchData = {
  bcbtCode: string
  nickname: string
  isManager: boolean
}

export type TeacherForBranchObject = {
  pagination: Pagination
  responses: TeacherForBranchData[]
}

@Component
export default class TeacherForBranchListApis extends Vue {
  /**
   * 教室情報取得
   */
  protected async getBranch(branchId: string): Promise<BranchData> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`/v1/branches/${branchId}`)
    return data
  }

  /**
   * 塾講師一覧取得
   */
  protected async searchTeacherForBranch(Page: number, branchId: string): Promise<TeacherForBranchObject> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(
      `/v1/academy/teacher_for_branch/${branchId}?page=${Page}`
    )
    return data
  }

  /**
   * 教室長フラグ更新
   */
  protected async teacherIsManagerUpdateApi(
    branchId: string,
    updateQuery: { bcbtCode: string; isManager: boolean }[],
    onSuccess: () => void,
    onError: () => void
  ) {
    await Vue.prototype.$http.httpWithToken
      .patch(`/v1/academy/teacher_for_branch/${branchId}`, {
        updateQuery,
      })
      .then(() => {
        onSuccess()
      })
      .catch(() => {
        onError()
      })
  }

  /**
   * 講師追加
   */
  protected async userTeacherAddApi(
    branchId: string,
    nickname: string,
    password: string,
    onSuccess: () => void,
    onError: (err: any) => void
  ) {
    await Vue.prototype.$http.httpWithToken
      .post(`/v1/academy/teacher/create`, {
        branchId: branchId,
        nickname: nickname,
        password: password,
      })
      .then(() => {
        onSuccess()
      })
      .catch((err: any) => {
        onError(err)
      })
  }

  /**
   * 氏名変更
   */
  protected async userNicknameUpdateApi(
    bcbtCode: string,
    nickname: string,
    onSuccess: () => void,
    onError: (err: any) => void
  ) {
    await Vue.prototype.$http.httpWithToken
      .patch(`/v1/academy/user/${bcbtCode}`, {
        nickname: nickname,
      })
      .then(() => {
        onSuccess()
      })
      .catch((err: any) => {
        onError(err)
      })
  }

  /**
   * パスワード変更
   */
  protected async userPasswordUpdateApi(
    bcbtCode: string,
    password: string,
    comfirmPassword: string,
    onSuccess: () => void,
    onError: (err: any) => void
  ) {
    await Vue.prototype.$http.httpWithToken
      .patch(`/v1/academy/user/${bcbtCode}`, {
        password: password,
        comfirmPassword: comfirmPassword,
      })
      .then(() => {
        onSuccess()
      })
      .catch((err: any) => {
        onError(err)
      })
  }

  /**
   * ユーザー削除
   */
  protected async userDeleteApi(bcbtCode: string, onSuccess: () => void, onError: () => void) {
    await Vue.prototype.$http.httpWithToken
      .delete(`/v1/academy/user/${bcbtCode}`)
      .then(() => {
        onSuccess()
      })
      .catch(() => {
        onError()
      })
  }
}
